import { Inline, RadioCard, RadioGroup, Stack, Text, vars } from '@etg/wings';
import { price as priceUtil } from '@eti/utils';
import { css } from '@eti/styles';
import { useDirection } from '@eti/providers';
import { CABIN_UPGRADE } from '../../../products';
import { getAvailablePerks, getSegmentUpgradeOptionKey, getSegmentUpgradePricePerTraveler } from '../../utils/utils';
import CabinUpgradePerks from './CabinUpgradePerks';
import { jsx as _jsx, jsxs as _jsxs, Fragment as _Fragment } from "react/jsx-runtime";
const {
  inputs
} = vars.colors;
const radioCardStyles = expanded => css`
  border-color: ${expanded ? inputs.main : inputs.border};
  border-radius: ${vars.card.borderRadius};
`;
const radioGroupStyles = css`
  margin-bottom: 16px;
`;
const upgradeOptionLabelStyles = css`
  align-items: center;
  display: flex;
  justify-content: space-between;
  width: 100%;
`;
const priceLabelTextStyle = isRTL => css`
  text-align: ${isRTL ? 'inherit' : 'end'};
`;
const CabinUpgradeAvailableOptions = _ref => {
  var _segmentUpgrade$upgra;
  let {
    drawerTexts,
    segmentKey,
    segmentUpgrade,
    selectedOptions,
    setSelectedOptions,
    setSegmentsWithoutUpgrade
  } = _ref;
  const {
    isRTL
  } = useDirection();
  if (!(segmentUpgrade !== null && segmentUpgrade !== void 0 && (_segmentUpgrade$upgra = segmentUpgrade.upgradeOptions) !== null && _segmentUpgrade$upgra !== void 0 && _segmentUpgrade$upgra.length)) {
    return null;
  }
  const {
    perks = [],
    perPersonLabel
  } = drawerTexts;
  const {
    boundIndex,
    segmentIndex,
    upgradeOptions = []
  } = segmentUpgrade || {};
  const handleChange = selectedOption => {
    setSelectedOptions(prev => {
      const filteredSelections = Object.keys(prev).reduce((acc, key) => {
        if (!key.includes(segmentKey)) {
          return {
            ...acc,
            [key]: prev[key]
          };
        }
        return acc;
      }, {});
      return {
        ...filteredSelections,
        [selectedOption.value]: {
          ...selectedOption,
          boundIndex,
          segmentIndex
        }
      };
    });
    setSegmentsWithoutUpgrade(prev => {
      return Object.keys(prev).reduce((acc, key) => {
        if (key !== segmentKey) {
          acc[key] = prev[key];
        }
        return acc;
      }, {});
    });
  };
  return /*#__PURE__*/_jsx(_Fragment, {
    children: upgradeOptions.map((upgradeOption, optionIndex) => {
      var _selectedOptions$upgr, _selectedOptions$upgr2, _selectedOptions$upgr3;
      const upgradeOptionKey = getSegmentUpgradeOptionKey({
        boundIndex,
        segmentIndex,
        optionIndex
      });
      const selectedOption = {
        upgradeOption,
        value: upgradeOptionKey
      };
      const price = getSegmentUpgradePricePerTraveler(upgradeOption === null || upgradeOption === void 0 ? void 0 : upgradeOption.travelers);
      const hasPrice = typeof price === 'number' && !Number.isNaN(price);
      const availablePerks = getAvailablePerks(perks, upgradeOption === null || upgradeOption === void 0 ? void 0 : upgradeOption.upgradeType);
      const shouldDisplayPerks = Boolean(((_selectedOptions$upgr = selectedOptions[upgradeOptionKey]) === null || _selectedOptions$upgr === void 0 ? void 0 : _selectedOptions$upgr.value) && availablePerks.length);
      return /*#__PURE__*/_jsx(RadioGroup, {
        className: radioGroupStyles,
        id: (_selectedOptions$upgr2 = selectedOptions[upgradeOptionKey]) === null || _selectedOptions$upgr2 === void 0 ? void 0 : _selectedOptions$upgr2.value,
        name: (upgradeOption === null || upgradeOption === void 0 ? void 0 : upgradeOption.upgradeType) || '',
        onChange: () => handleChange(selectedOption),
        selectedValue: ((_selectedOptions$upgr3 = selectedOptions[upgradeOptionKey]) === null || _selectedOptions$upgr3 === void 0 ? void 0 : _selectedOptions$upgr3.value) || '',
        children: /*#__PURE__*/_jsx(RadioCard, {
          className: radioCardStyles(Boolean(selectedOptions[upgradeOptionKey])),
          label: /*#__PURE__*/_jsxs(Inline, {
            className: upgradeOptionLabelStyles,
            children: [/*#__PURE__*/_jsx(Text, {
              variant: "14-bold",
              children: upgradeOption === null || upgradeOption === void 0 ? void 0 : upgradeOption.upgradeType
            }), hasPrice && /*#__PURE__*/_jsxs(Stack, {
              "data-testid": `${CABIN_UPGRADE.name}-${upgradeOptionKey}-price`,
              spacing: 0,
              children: [/*#__PURE__*/_jsx(Text, {
                as: "bdi",
                variant: "18-emphasized",
                children: `+${priceUtil.formatPrice(price)}`
              }), /*#__PURE__*/_jsx(Text, {
                as: "bdi",
                className: priceLabelTextStyle(isRTL),
                children: perPersonLabel
              })]
            })]
          }),
          value: selectedOption.value,
          children: shouldDisplayPerks && /*#__PURE__*/_jsx(CabinUpgradePerks, {
            availablePerks: availablePerks,
            segmentKey: segmentKey
          })
        })
      }, `option-${optionIndex}`);
    })
  });
};
export default CabinUpgradeAvailableOptions;
//# sourceMappingURL=CabinUpgradeAvailableOptions.js.map